var map = {
	"./images/tech-writing.png": 621
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1480;


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations ^.*\/tech\-writing\.png$
// module id = 1480
// module chunks = 146